import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./Teleport.css";
import { Link } from "react-router-dom";
// import EtmWrap from '../../assets/ethWrap.png'
import ETH1 from "../../assets/ethYellow.png";
import eth2 from "../../assets/ethWrap.png";
import eth3 from "../../assets/arrrooo.svg";
import ETH from "../../assets/ETH.png";
import ETH4 from "../../assets/Vector (1).svg";
import imge3 from "../../assets/bnb.png";
import imge4 from "../../assets/imge1.png";
import imge5 from "../../assets/SOL.png";
import imge6 from "../../assets/imge4.png";
// import img7 from '../../assets/Swatch.svg'
import Footer from "../footer/Footer";

const Teleport = () => {
  const [drop,setDrop] = React.useState(false);
  const [dropdown,setDropdown] = React.useState(false);
  const [dropdownList,setDropdownList] = React.useState(false);
  return (
    <>
      <div>
        <div className="teleportBackGroud">
          <div className="container">
            <div className="cal-md-12">
              <div className="col-xl-5 col-md-6 col-12  teleportBtnSwapDiv">
                <Link to="">
                  <button className="btn teleportBtnSwap1">Teleport</button>
                </Link>
                <Link to="/energize">
                  <button className="btn teleportBtnSwap2" style={{borderRadius:'0', borderTopRightRadius:'7px', borderBottomRightRadius:'7px'}}>Energize</button>
                </Link>
              </div>
              <div className="col-xl-5 col-lg-7 col-md-9 m-auto">
                <div className="row">
                  <div className="col-md-12 teleportOuter">
                    <div className="aknsakn">
                      <div className="teleportHeadingDiv">
                        <p className="teleportHeading">From</p>
                      </div>
                      <div className="col-md-12 teleportIner">
                        <div className="col-md-6 ">
                          <div className="teleportImgePra">
                            <img alt="" src={ETH} />
                            <span className="teleportSpan1">
                              Ethereum Mainnet
                            </span>
                          </div>
                        </div>
                        <div className="col-md-2 teleportpMd">
                          <div>
                            <img alt="" src={eth3} onClick={e => setDrop(!drop)}/>
                         {drop && (
                          <div className="dropdown">
                          <ul onClick={e => setDrop(!drop)}>
                          <li style={{display:'flex'}}> <img src={ETH} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}>Ethereum Mainnet</span> </li>
                          <li style={{display:'flex'}}> <img src={imge3} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}>BSC</span></li>
                          <li style={{display:'flex'}}><img src={imge4} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}>Polygon Mainnet</span> </li>
                          <li  style={{display:'flex'}}><img src={imge5} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}>Solana</span></li>
                          <li  style={{display:'flex'}}><img src={imge6} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}> Avalanche</span></li>
                          </ul>
                          </div>
                          )}    
                          </div>
                        </div>
                        <div className="col-md-4 teleportpMd">
                          <div>
                            <p className="teleportPara3">
                              {" "}
                              <span className="teleportSpan2">Bal: </span>
                             <span style={{fontWeight:'500'}} className='adjust'> 0.00 FTMA{" "}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 teleportIner">
                        {/* <div className='col-md-6'>
               <p className='teleportPara1'>0.00</p>
             </div> */}
                        <div className="col-md-5 ">
                          <div className="teleportImgePra">
                            <img alt="" src={eth2} />
                            <span className="teleportSpan1">FTMA</span>
                            <img alt="" className="teleportEth2" src={eth3} onClick={e => setDropdown(!dropdown)}/>
                         {dropdown && (
                          <div className="dropdown">
                          <ul style={{left:'-5.8rem'}} onClick={e => setDropdown(!dropdown)}>
                          <li style={{display:'flex'}}> <img src={ETH} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}} >Ethereum Mainnet</span> </li>
                          <li style={{display:'flex'}}> <img src={imge3} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}>BSC</span></li>
                          <li style={{display:'flex'}}><img src={imge4} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}>Polygon Mainnet</span> </li>
                          <li  style={{display:'flex'}}><img src={imge5} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}>Solana</span></li>
                          <li  style={{display:'flex'}}><img src={imge6} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}}> Avalanche</span></li>
                          </ul>
                          </div>
                          )}   
                          </div>
                        </div>

                        <div className="col-md-7 teleportNewDiv ">
                          <div>
                            <input
                              className="teleportNewNumber"
                              type="number"
                              placeholder="0.00"
                            />
                          </div>
                          <div>
                            <p className="teleportNewNmae">MAX</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 teleportDropDown">
                        <img alt="" src={ETH4} />
                      </div>
                      <div className="col-md-12 teleportIner">
                        {/* <div className='col-md-6'>
               <p className='teleportPara1'>0.00</p>
             </div> */}
                        <div className="col-md-6 ">
                          <div className="teleportImgePra">
                            <img alt="" src={ETH1} />
                            <span className="teleportSpan1">
                              Binance Smart Chain
                            </span>
                          </div>
                        </div>
                        <div className="col-md-2 teleportpMd">
                          <div>
                            <img alt="" src={eth3} onClick={e => setDropdownList(!dropdownList)}/>
                         {dropdownList && (
                          <div className="dropdown">
                          <ul style={{left:'-5.8rem'}} onClick={e => setDropdownList(!dropdownList)} >
                          <li style={{display:'flex'}}> <img src={ETH} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}} onClick={e => setDropdownList(!dropdownList)}>Ethereum Mainnet</span> </li>
                          <li style={{display:'flex'}}> <img src={imge3} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}} onClick={e => setDropdownList(!dropdownList)}>BSC</span></li>
                          <li style={{display:'flex'}}><img src={imge4} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}} onClick={e => setDropdownList(!dropdownList)}>Polygon Mainnet</span> </li>
                          <li  style={{display:'flex'}}><img src={imge5} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}} onClick={e => setDropdownList(!dropdownList)}>Solana</span></li>
                          <li  style={{display:'flex'}}><img src={imge6} alt="" style={{ width: '25px',height: '25px'}}/> <span style={{marginLeft: '18px'}} onClick={e => setDropdownList(!dropdownList)}> Avalanche</span></li>
                          </ul>
                          </div>
                          )}   
                          </div>
                        </div>
                        <div className="col-md-4 teleportpMd">
                          <div>
                            <p className="teleportPara3">
                              {" "}
                              <span className="teleportSpan2">Bal: </span>
                             <span style={{fontWeight:'500'}} className='adjust'>0.00 ETH{" "}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="teleportBtnDvi">
                        <button className="btn btn-success teleportBtn">
                          Teleport
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="outersgsgsggg">
          <img alt="" src={img7} />
          </div> */}
      </div>
      <Footer />
    </>
  );
};

export default Teleport;
